/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, plural: NonNullable<unknown> }} Network_Vehicles_Archived_CountInputs */

const fr_network_vehicles_archived_count = /** @type {(inputs: Network_Vehicles_Archived_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} véhicule${i?.plural} archivé${i?.plural}`)
};

const en_network_vehicles_archived_count = /** @type {(inputs: Network_Vehicles_Archived_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} archived vehicle${i?.plural}`)
};

/**
* | output |
* | --- |
* | "{count} archived vehicle{plural}" |
*
* @param {Network_Vehicles_Archived_CountInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const network_vehicles_archived_count = /** @type {((inputs: Network_Vehicles_Archived_CountInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Network_Vehicles_Archived_CountInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_network_vehicles_archived_count(inputs)
	return en_network_vehicles_archived_count(inputs)
});